import { APIProvider, Map } from '@vis.gl/react-google-maps'
import { PropsWithChildren } from 'react'

import { MapsProps } from '#/components/Maps'
import { useUserLocale } from '#/store/ducks/auth'

type MapWrapperProps = MapsProps & PropsWithChildren

const defaultMapOptions = {
  keyboardShortcuts: false,
  mapTypeControl: false,
  rotateControl: false,
  streetViewControl: false,
  tilt: 0,
}

// Define idioma e região com base no locale do usuário
// 'region' ajuda a priorizar locais com nomes ambíguos

// prettier-ignore
const regionConfigs = {
  en:     { language: 'en', region: 'US' },      // Estados Unidos
  es:     { language: 'es', region: '419' },     // América Latina e Caribe
  pt_BR:  { language: 'pt-BR', region: 'BR' },   // Brasil
}

const apiKey = import.meta.env.VITE_GOOGLEMAP_API_KEY!
const mapId = import.meta.env.VITE_GOOGLEMAP_ID!

export function MapWrapper({
  center,
  children,
  height = '50vh',
  id,
  mapTypeId,
  zoom = 3,
}: MapWrapperProps) {
  const locale = useUserLocale()
  const regionProps = regionConfigs[locale ?? 'en']

  return (
    <APIProvider apiKey={apiKey} {...regionProps} libraries={['marker']}>
      <Map
        id={id}
        defaultCenter={center}
        defaultZoom={zoom}
        mapId={mapId}
        mapTypeId={mapTypeId}
        style={{
          borderRadius: 16,
          height,
          overflow: 'hidden',
        }}
        {...defaultMapOptions}
      >
        {children}
      </Map>
    </APIProvider>
  )
}
